import React, { useState } from 'react';
import Header from '../components/Header';

const C = {
  attivita: '#FF5B00',
  attivitaDark: '#cc4800',
  attivitaLight: '#fff2eb',
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const TIPOLOGIE = [
  {
    id: 'cultura',
    emoji: '🏛️',
    nome: 'Musei e Cultura',
    tagline: 'Arte, storia e patrimonio',
    descrizione: 'Musei, gallerie d\'arte, siti archeologici e patrimoni UNESCO. Confronta prezzi d\'ingresso, orari, code stimate e la possibilità di prenotare online con salto della fila.',
    perchi: ['Culturali', 'Famiglie', 'Appassionati di storia'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '🎟️', txt: 'Prezzo biglietto intero, ridotto, bambini e famiglie' },
      { ico: '⏰', txt: 'Orari di apertura, giorni di chiusura e ultima entrata' },
      { ico: '📱', txt: 'Prenotazione online e salto della fila' },
      { ico: '🗣️', txt: 'Audioguide disponibili e lingue supportate' },
      { ico: '♿', txt: 'Accessibilità per persone con disabilità' },
      { ico: '⏱️', txt: 'Durata media della visita e affollamento per fascia oraria' },
    ],
  },
  {
    id: 'tour',
    emoji: '🧭',
    nome: 'Tour Guidati',
    tagline: 'Scopri la destinazione con una guida',
    descrizione: 'Walking tour, tour in bus, giri in barca e tour tematici. Confronta durata, lingue disponibili, dimensione del gruppo e se il tour è privato o condiviso.',
    perchi: ['Prime visite', 'Coppie', 'Solitari'],
    prezzo: '€ – €€€',
    cosa_confronti: [
      { ico: '🚶', txt: 'Walking tour, bus tour, bike tour o giro in barca' },
      { ico: '👥', txt: 'Gruppo piccolo (max 8), condiviso o tour privato' },
      { ico: '🗣️', txt: 'Lingua della guida: italiano, inglese, spagnolo...' },
      { ico: '⏱️', txt: 'Durata: da 1 ora a tour di intera giornata' },
      { ico: '📍', txt: 'Punto di partenza, percorso e tappe incluse' },
      { ico: '🎟️', txt: 'Ingressi inclusi nel prezzo o da pagare a parte' },
    ],
  },
  {
    id: 'sport',
    emoji: '🏄',
    nome: 'Sport e Avventura',
    tagline: 'Adrenalina e movimento',
    descrizione: 'Surf, trekking, arrampicata, diving, paracadute e molto altro. Confronta livello richiesto, attrezzatura inclusa, certificazioni delle guide e politiche di sicurezza.',
    perchi: ['Avventurieri', 'Sportivi', 'Under 40'],
    prezzo: '€€ – €€€€',
    cosa_confronti: [
      { ico: '🎯', txt: 'Livello richiesto: principiante, intermedio, esperto' },
      { ico: '🦺', txt: 'Attrezzatura inclusa o da noleggiare separatamente' },
      { ico: '📜', txt: 'Certificazioni guide e protocolli di sicurezza' },
      { ico: '🌤️', txt: 'Stagionalità e condizioni meteo minime' },
      { ico: '👶', txt: 'Età minima e limitazioni fisiche' },
      { ico: '📸', txt: 'Foto e video dell\'esperienza inclusi o opzionali' },
    ],
  },
  {
    id: 'cucina',
    emoji: '🍽️',
    nome: 'Esperienze Culinarie',
    tagline: 'Il gusto del posto',
    descrizione: 'Cooking class, degustazioni di vini e olio, tour gastronomici nei mercati locali e cene con chef. Il modo migliore per immergersi nella cultura di una destinazione.',
    perchi: ['Foodies', 'Coppie', 'Famiglie'],
    prezzo: '€€ – €€€',
    cosa_confronti: [
      { ico: '👨‍🍳', txt: 'Cooking class: ricette locali, ingredienti e degustazione' },
      { ico: '🍷', txt: 'Wine tasting, degustazione olio e prodotti tipici' },
      { ico: '🏪', txt: 'Tour nei mercati locali con guida e assaggi inclusi' },
      { ico: '🍴', txt: 'Cena con chef locale in contesto privato' },
      { ico: '🌿', txt: 'Opzioni vegetariane, vegane e allergie gestite' },
      { ico: '🎁', txt: 'Ricettario o prodotti locali inclusi come souvenir' },
    ],
  },
  {
    id: 'spettacoli',
    emoji: '🎭',
    nome: 'Spettacoli ed Eventi',
    tagline: 'Cultura viva della destinazione',
    descrizione: 'Concerti, teatro, flamenco, opera, folklore e spettacoli tradizionali. Confronta date, posti disponibili, categoria di seduta e include la cena.',
    perchi: ['Culturali', 'Coppie', 'Appassionati di musica'],
    prezzo: '€ – €€€€',
    cosa_confronti: [
      { ico: '🪑', txt: 'Categoria posti: platea, balconata, palco o lounge' },
      { ico: '📅', txt: 'Date disponibili e orari delle rappresentazioni' },
      { ico: '🍽️', txt: 'Cena inclusa o spettacolo + cena combinati' },
      { ico: '🌍', txt: 'Lingua dello spettacolo e disponibilità sovrattitoli' },
      { ico: '⏱️', txt: 'Durata totale e eventuali intervalli' },
      { ico: '🔄', txt: 'Politica di rimborso in caso di cancellazione' },
    ],
  },
  {
    id: 'natura',
    emoji: '🌲',
    nome: 'Escursioni Naturalistiche',
    tagline: 'Paesaggi e ambienti unici',
    descrizione: 'Parchi nazionali, safari, boat tour, whale watching e trekking in natura. Confronta stagione migliore, distanza dalla città, trasporto incluso e attrezzatura necessaria.',
    perchi: ['Amanti della natura', 'Famiglie', 'Fotografi'],
    prezzo: '€ – €€€',
    cosa_confronti: [
      { ico: '🚌', txt: 'Trasporto incluso dall\'hotel o punto di raccolta' },
      { ico: '📅', txt: 'Stagione migliore e probabilità di avvistamento' },
      { ico: '🥾', txt: 'Difficoltà del percorso e attrezzatura consigliata' },
      { ico: '🌅', txt: 'Orario (alba, mattina, tramonto) e durata' },
      { ico: '🐾', txt: 'Ammissione animali domestici al parco' },
      { ico: '🎒', txt: 'Cosa portare: acqua, scarpe, crema solare, binocolo' },
    ],
  },
];

const STEPS = [
  {
    num: '1',
    titolo: 'Scegli le categorie',
    testo: 'Seleziona solo i tipi di attività che ti interessano. Sei in viaggio per cultura? Nascondi sport e avventura.',
    colore: C.attivita,
  },
  {
    num: '2',
    titolo: 'Filtra per data e durata',
    testo: 'Imposta i giorni disponibili, la durata massima e la fascia oraria preferita (mattina, pomeriggio o sera).',
    colore: C.alloggio,
  },
  {
    num: '3',
    titolo: 'Confronta e prenota',
    testo: 'Vedi le opzioni affiancate con prezzi, recensioni e disponibilità. Prenota direttamente o aggiungi alla lista dei desideri.',
    colore: C.servizi,
  },
  {
    num: '4',
    titolo: 'Aggiungi all\'esperienza',
    testo: 'Le attività scelte si aggiungono all\'itinerario OCTA giorno per giorno, insieme ad alloggio e trasporti.',
    colore: C.trasporto,
  },
];

export default function Attivita() {
  const [attive, setAttive] = useState(new Set(TIPOLOGIE.map(t => t.id)));
  const [aperta, setAperta] = useState(null);

  const toggleTipo = (id) => {
    setAttive(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        if (next.size > 1) next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const selezionaTutte = () => setAttive(new Set(TIPOLOGIE.map(t => t.id)));
  const tipologieVisibili = TIPOLOGIE.filter(t => attive.has(t.id));

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.88; }
        .octa-hamburger { display: none; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 24px !important; }
          .octa-hero { padding: 52px 32px 60px !important; }
          .octa-hero h1 { font-size: 38px !important; }
          .octa-section { padding: 52px 32px !important; }
          .octa-footer { padding: 24px 32px !important; }
        }
        @media (max-width: 640px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .octa-hero { padding: 48px 20px 56px !important; }
          .octa-hero h1 { font-size: 34px !important; }
          .octa-section { padding: 48px 20px !important; }
          .octa-card-grid { grid-template-columns: 1fr !important; }
          .octa-steps-grid { grid-template-columns: 1fr !important; }
          .octa-footer { padding: 24px 16px !important; flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
          .octa-cta-btns { flex-direction: column !important; }
          .octa-cta-btns a { text-align: center !important; }
        }
        @media (max-width: 900px) {
          .octa-card-grid { grid-template-columns: 1fr 1fr !important; }
          .octa-steps-grid { grid-template-columns: 1fr 1fr !important; }
        }
        .tipo-pill { transition: all 0.15s ease; }
        .tipo-pill:hover { transform: translateY(-1px); }
        .card-att { transition: box-shadow 0.15s ease; }
        .card-att:hover { box-shadow: 0 8px 32px rgba(255,91,0,0.12); }
      `}</style>

      <Header bg={C.attivita} />

      {/* HERO */}
      <section className="octa-hero" style={{ backgroundColor: C.attivita, padding: '68px 60px 76px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '7px 18px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', marginBottom: '28px' }}>
            <img src="/images/attivita_icona.png" alt="Attività" style={{ height: '18px' }} onError={e => { e.target.style.display = 'none'; }} />
            <span style={{ fontSize: '13px', fontWeight: 700, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Segmento Attività</span>
          </div>
          <h1 style={{ fontSize: '50px', fontWeight: 900, color: C.white, lineHeight: 1.1, marginBottom: '20px' }}>
            Cosa fai,<br />
            <span style={{ color: C.white }}>scegli tu come viverlo.</span>
          </h1>
          <p style={{ fontSize: '17px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.75, maxWidth: '600px', margin: '0 auto 36px' }}>
            Musei, tour guidati, sport, cucina locale, spettacoli e natura: confronta le categorie di attività e tieni solo quelle che fanno per te.
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {TIPOLOGIE.map(t => (
              <span key={t.id} style={{ padding: '6px 14px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: C.white, fontSize: '13px', fontWeight: 600 }}>
                {t.emoji} {t.nome}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* BANNER COMING SOON */}
      <div style={{ backgroundColor: '#fffbeb', borderBottom: '1px solid #fde68a', padding: '13px 40px', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', color: '#92400e', fontWeight: 600 }}>
          🚀 La ricerca comparativa in tempo reale è in arrivo — per ora condividi le attività dei tuoi viaggi e scopri quelle della community.
        </p>
      </div>

      {/* SELETTORE TIPOLOGIE */}
      <section className="octa-section" style={{ padding: '64px 60px', backgroundColor: C.white }}>
        <div style={{ maxWidth: '1060px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px', marginBottom: '36px' }}>
            <div>
              <p style={{ fontSize: '12px', fontWeight: 700, color: C.attivita, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Personalizza la ricerca</p>
              <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, lineHeight: 1.2 }}>Seleziona le categorie che ti interessano</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '13px', color: C.textLight }}>{attive.size} di {TIPOLOGIE.length} attive</span>
              {attive.size < TIPOLOGIE.length && (
                <button onClick={selezionaTutte} style={{ padding: '7px 16px', borderRadius: '20px', border: `1px solid ${C.attivita}`, backgroundColor: 'transparent', color: C.attivita, fontSize: '13px', fontWeight: 600 }}>
                  Seleziona tutte
                </button>
              )}
            </div>
          </div>

          {/* PILL SELECTOR */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '48px' }}>
            {TIPOLOGIE.map(t => {
              const isOn = attive.has(t.id);
              return (
                <button
                  key={t.id}
                  className="tipo-pill"
                  onClick={() => toggleTipo(t.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '9px',
                    padding: '11px 22px', borderRadius: '50px',
                    border: `2px solid ${isOn ? C.attivita : C.border}`,
                    backgroundColor: isOn ? C.attivita : C.white,
                    color: isOn ? C.white : C.textLight,
                    fontSize: '14px', fontWeight: 700,
                    boxShadow: isOn ? `0 4px 16px rgba(255,91,0,0.25)` : 'none',
                  }}
                >
                  <span style={{ fontSize: '18px' }}>{t.emoji}</span>
                  {t.nome}
                  {isOn && <span style={{ fontSize: '12px', opacity: 0.75 }}>✓</span>}
                </button>
              );
            })}
          </div>

          {/* GRIGLIA CARD */}
          <div className="octa-card-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {tipologieVisibili.map(t => {
              const isAperta = aperta === t.id;
              return (
                <div
                  key={t.id}
                  className="card-att"
                  style={{ backgroundColor: C.white, borderRadius: '18px', border: `1px solid ${isAperta ? C.attivita : C.border}`, borderTop: `3px solid ${C.attivita}`, overflow: 'hidden', cursor: 'pointer' }}
                  onClick={() => setAperta(isAperta ? null : t.id)}
                >
                  <div style={{ padding: '24px 24px 20px', borderBottom: `1px solid ${C.border}` }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontSize: '28px' }}>{t.emoji}</span>
                        <div>
                          <h3 style={{ fontSize: '17px', fontWeight: 800, color: C.text }}>{t.nome}</h3>
                          <p style={{ fontSize: '11px', color: C.attivita, fontWeight: 700 }}>{t.tagline}</p>
                        </div>
                      </div>
                      <span style={{ fontSize: '18px', color: C.textLight, flexShrink: 0, marginTop: '2px' }}>{isAperta ? '▲' : '▼'}</span>
                    </div>
                    <p style={{ fontSize: '13px', color: C.textLight, lineHeight: 1.6 }}>{t.descrizione}</p>
                  </div>
                  <div style={{ padding: '14px 24px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div>
                      <p style={{ fontSize: '10px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '3px' }}>Prezzo medio</p>
                      <p style={{ fontSize: '14px', fontWeight: 800, color: C.attivita }}>{t.prezzo}</p>
                    </div>
                    <div style={{ width: '1px', height: '28px', backgroundColor: C.border }} />
                    <div>
                      <p style={{ fontSize: '10px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Ideale per</p>
                      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                        {t.perchi.map(p => (
                          <span key={p} style={{ padding: '2px 8px', borderRadius: '10px', backgroundColor: C.attivitaLight, color: C.attivita, fontSize: '11px', fontWeight: 600 }}>{p}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  {isAperta && (
                    <div style={{ padding: '0 24px 20px', borderTop: `1px solid ${C.border}` }}>
                      <p style={{ fontSize: '11px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', margin: '16px 0 12px' }}>Cosa puoi confrontare</p>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
                        {t.cosa_confronti.map((v, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            <span style={{ fontSize: '15px', flexShrink: 0, marginTop: '1px' }}>{v.ico}</span>
                            <span style={{ fontSize: '13px', color: C.text, lineHeight: 1.5 }}>{v.txt}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {tipologieVisibili.length > 0 && (
            <p style={{ fontSize: '13px', color: C.textLight, textAlign: 'center', marginTop: '20px' }}>
              Clicca su una card per vedere nel dettaglio cosa puoi confrontare.
            </p>
          )}
        </div>
      </section>

      {/* COME FUNZIONA */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.light }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '52px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, color: C.attivita, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Come funziona</p>
            <h2 style={{ fontSize: '34px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Pianifica le attività in 4 passi</h2>
            <p style={{ fontSize: '16px', color: C.textLight, maxWidth: '500px', margin: '0 auto' }}>
              Dalla scelta delle categorie all\'itinerario definitivo, costruisci giorno per giorno quello che vuoi fare.
            </p>
          </div>
          <div className="octa-steps-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {STEPS.map((step, i) => (
              <div key={i} style={{ padding: '28px 22px', borderRadius: '16px', backgroundColor: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${step.colore}`, textAlign: 'center' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', backgroundColor: step.colore, color: C.white, fontSize: '17px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>{step.num}</div>
                <h3 style={{ fontSize: '15px', fontWeight: 800, color: C.text, marginBottom: '10px' }}>{step.titolo}</h3>
                <p style={{ fontSize: '13px', color: C.textLight, lineHeight: 1.65 }}>{step.testo}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEZIONE DARK: COSTRUISCI L'ITINERARIO */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.attivita }}>
        <div style={{ maxWidth: '860px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Itinerario giornaliero</p>
          <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.white, marginBottom: '16px' }}>Ogni giorno ha il suo programma</h2>
          <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.75, maxWidth: '600px', margin: '0 auto 44px' }}>
            Le attività si collegano automaticamente all\'itinerario giorno per giorno. Vedi cosa hai in programma la mattina, il pomeriggio e la sera — e modifica in qualsiasi momento.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '14px' }}>
            {[
              { ico: '🌅', titolo: 'Mattina', desc: 'Musei, tour e visite culturali — quando c\'è meno folla.' },
              { ico: '☀️', titolo: 'Pomeriggio', desc: 'Sport, escursioni e attività all\'aperto nelle ore di luce.' },
              { ico: '🌙', titolo: 'Sera', desc: 'Spettacoli, cene speciali ed esperienze culinarie locali.' },
              { ico: '📋', titolo: 'Giorno libero', desc: 'Segna i giorni senza programma per esplorare in autonomia.' },
            ].map((f, i) => (
              <div key={i} style={{ padding: '22px 20px', borderRadius: '14px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)', textAlign: 'left' }}>
                <span style={{ fontSize: '26px', display: 'block', marginBottom: '10px' }}>{f.ico}</span>
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: C.white, marginBottom: '7px' }}>{f.titolo}</h4>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="octa-section" style={{ padding: '80px 60px', backgroundColor: C.white, textAlign: 'center' }}>
        <div style={{ maxWidth: '580px', margin: '0 auto' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '18px', backgroundColor: C.attivitaLight, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: '30px' }}>🎭</div>
          <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Hai fatto qualcosa di speciale?<br />Condividilo con la community.</h2>
          <p style={{ fontSize: '16px', color: C.textLight, lineHeight: 1.7, marginBottom: '36px' }}>
            Aggiungi le attività alla tua esperienza OCTA — insieme ad alloggio, trasporti e servizi — e ispira altri viaggiatori che andranno nella stessa destinazione.
          </p>
          <div className="octa-cta-btns" style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/crea" style={{ padding: '15px 32px', borderRadius: '50px', backgroundColor: C.attivita, color: C.white, fontSize: '15px', fontWeight: 700 }}>
              + Crea un'esperienza
            </a>
            <a href="/bacheca" style={{ padding: '15px 32px', borderRadius: '50px', border: `2px solid ${C.border}`, color: C.textLight, fontSize: '15px', fontWeight: 600 }}>
              Esplora la bacheca
            </a>
          </div>
        </div>
      </section>

      {/* ALTRI SEGMENTI */}
      <section style={{ padding: '40px 60px', backgroundColor: C.light, borderTop: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '18px' }}>Esplora gli altri segmenti</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { label: 'Trasporto', color: C.trasporto, href: '/trasporto' },
              { label: 'Alloggio', color: C.alloggio, href: '/alloggio' },
              { label: 'Servizi', color: C.servizi, href: '/servizi' },
            ].map(seg => (
              <a key={seg.label} href={seg.href} style={{ padding: '10px 24px', borderRadius: '50px', border: `2px solid ${seg.color}`, color: seg.color, fontSize: '14px', fontWeight: 700, backgroundColor: C.white }}>
                {seg.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="octa-footer" style={{ padding: '32px 60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.attivita, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}
